import React from 'react'

import './clubProductTag.scss'
import { ProductCardTopFlagImage } from '../ProductCardTopFlagImage'
interface ClubProductTagProps {
  text: string
  afterPriceLocation?: boolean
  activatePlusFriendBadge?: boolean
}

export const ClubProductTag = ({
  text,
  afterPriceLocation,
  activatePlusFriendBadge,
}: ClubProductTagProps) => {
  return (
    <div>
      {activatePlusFriendBadge ? (
        <ProductCardTopFlagImage />
      ) : (
        <div
          className={
            afterPriceLocation
              ? `club-product-flag-after-price `
              : 'club-product-flag'
          }
        >
          <p>{text}</p>
        </div>
      )}
    </div>
  )
}
